// Sound that does not go through the ArrangementPlayer — an <audio> element
// playing a download's render, a stem preview on the upload page — still
// has to answer the room's Stop and Space. Anything that starts one
// registers how to stop it here; the playback facade (hooks/usePlayback.ts)
// stops them all with the previews it owns.
//
// Module state on purpose: the players live in hooks on pages that know
// nothing of each other, and one stop must reach every one of them.

const stops = new Set<() => void>();

/** Register a running external preview; call the returned function once it
 * has stopped on its own (or to take it out of Stop's reach). */
export function registerExternalPreview(stop: () => void): () => void {
  stops.add(stop);
  return () => {
    stops.delete(stop);
  };
}

/** Stop every registered external preview. */
export function stopExternalPreviews(): void {
  for (const stop of [...stops]) stop();
  stops.clear();
}

/** How many are registered — tests and the dev inspector. */
export function externalPreviewCount(): number {
  return stops.size;
}
